import { Component } from "../components/component"
import { ComponentState } from "../types/componentState.enum"
import ComponentError from "../util/error/componentError"

export const handleComponentError = (className: string) => {
    return function (_: any, __: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value

        descriptor.value = function (this: Component, ...args) {
            if (this.state === ComponentState.ERROR) {
                return
            }
            try {
                return originalMethod.apply(this, args)
            } catch (error) {
                console.error(error)

                if (error instanceof Error) {
                    this.state = ComponentState.ERROR

                    new ComponentError({
                        error,
                        componentName: className,
                        componentProperties: { ...this?.props }
                    })
                }
            }
        }

        return descriptor
    }
}
